import React from 'react';
import { Photographer, Order } from '../../BookingsCalendarTypes';
import MapComponentMarker from './MapComponentMarker';
import useMap from '../../state/useMap';

interface MapComponentProps {
    photographers: Photographer[];
    selectedOrder: Order;
}

const MapComponent: React.FC<MapComponentProps> = ({ selectedOrder, photographers }) => {

    const { map, markerList, mapRef } = useMap(selectedOrder, photographers)

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <div ref={mapRef} style={{ height: '100%', width: '100%' }} />
            {map && markerList().map((marker, index) => (
                <MapComponentMarker
                    key={index}
                    map={map}
                    position={{ lat: marker.latitude, lng: marker.longitude }}
                    marker={marker}
                />
            ))}
        </div>
    );
};

export default MapComponent;
